import { t } from 'i18next';
import React from 'react';
import CustomMiniCard from '../../../../components/CustomMiniCard';
import { userType } from '../../../../enums/userTypeEnum';
import { getDateFormat } from '../../../../Apis/functions';
import CustomImageTable from '../../../../components/CustomImageTable';
import {accessMethod, accessMethodModel} from '../../../../enums/accessMethodEnum';
import NotInformation from '../../../../components/NotInformation';
import RowCardText from '../../../../components/RowCardText';
import { colors } from '../../../../enums/colors';
import CustomChip from '../../../../components/CustomChip';
import {getDeviceAccessTypeById} from "../../Devices/Model/Model";

const UserAccessLogs = ({ list }) => {

    const getIcon = (accessMethodId) => {
        const match = Object.values(accessMethodModel).find(
            (method) => method.id === accessMethodId
        );
        return match?.icon;
    };

    return (<>
        {list?.length > 0 ?
            <>
                {list?.map((access) => {
                    let deviceAccessType = getDeviceAccessTypeById(access?.deviceAccessTypeId);
                    return (
                        <CustomMiniCard>

                            <div className='px-0 d-flex justify-content-between'>
                                <CustomChip
                                    background={access.success === true ? colors.green : colors.red}
                                />
                                <RowCardText title={''} value={getDateFormat(access.createdAt, true)} />
                            </div>

                            <div className='row'>
                                <div className='col-6 px-0'>
                                    <RowCardText title={t('name')} value={access?.userFullName || '-'} />
                                    <RowCardText title={t('user_type')}  value={t(userType[access?.userTypeId])} />
                                    <RowCardText title={t('zone')} value={access?.zoneName || '-'} />
                                </div>

                                <div className='col-6 d-flex justify-content-end gap-4 mt-2 px-0'>
                                    <CustomImageTable classNameImage={deviceAccessType.color} icon={<deviceAccessType.Icon/>}/>
                                    <CustomImageTable tooltip={t(accessMethod[access.accessMethodId]).toUpperCase()}
                                        image={getIcon(access.accessMethodId)}
                                    />
                                </div>
                            </div>

                        </CustomMiniCard>
                    );
                })}
            </>
            :
            <NotInformation text={t('no_information')} card={true} />
        }
    </>);
}

export default UserAccessLogs;
